<template>
  <GtcModal
    :open="props.open"
    :title="t('modals.common.noAccountTradingModal.title')"
    :loading="props.loading || props.pending"
    width="400px"
    :ok-text="t('modals.common.noAccountTradingModal.confirm')"
    :cancel-text="t('modals.common.noAccountTradingModal.cancel')"
    @ok="handleOk"
    @cancel="$emit('cancel')"
  >
    <div class="w-full mt-8 mb-16 gap-4 ink-16 text-ink-950 font-medium">
      <span>{{ t('modals.common.noAccountTradingModal.description') }}</span>
    </div>
  </GtcModal>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import GtcModal from '@/components/gtc-modal/GtcModal.vue'

const emit = defineEmits<{
  cancel: []
  confirm: []
}>()

const { t } = useI18n()

const props = withDefaults(
  defineProps<{
    open: boolean
    loading?: boolean
    pending?: boolean
  }>(),
  {
    loading: false,
    pending: false,
  },
)

const handleOk = () => {
  emit('confirm')
}
</script>
